/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/30/2022.
 */

import {apiUrl, handleApiCall, securedApiOptions} from './HttpUtils'

const getLearningLoopApiUrl = () => {
    return apiUrl(`/learningLoop`)
}

export const fetchLearningLoopPackets = (ldiId, filter) => {
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(apiUrl('/faults/exported') + composeQuery(filter) + '&ldiId=' + ldiId, opts)
}

export const countLearningLoopPackets = (ldiId, filter) => {
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(apiUrl('/faults/exported/count') + composeQuery(filter) + '&ldiId=' + ldiId, opts)
}

export const exportLearningLoopPacket = (ldiId) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    return handleApiCall(getLearningLoopApiUrl() + '/synchronize' + '?ldiId=' + ldiId, opts)
}

export const reexportLearningLoopPacket = (faultId, assetId) => {
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(getLearningLoopApiUrl() + '/resynchronize' + '?faultId=' + faultId + '&assetId=' + assetId, opts)
}

const composeQuery = (filter) => {
    let query = "?";
    if (filter.start >= 0) {
        query += "&start=" + filter.start
    }
    if (filter.limit) {
        query += "&limit=" + filter.limit
    }
    if (filter.exportedStates) {
        for (const i in filter.exportedStates) {
            if (filter.exportedStates.hasOwnProperty(i)) {
                query += "&exportedStates=" + filter.exportedStates[i]
            }
        }
    }
    return (query);
}

export const checkUpdate = (ldiId) => {
    const opts = securedApiOptions()
    return handleApiCall(getLearningLoopApiUrl() + '/update' + '?ldiId=' + ldiId, opts)
}

export const update = (ldiId) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    return handleApiCall(getLearningLoopApiUrl() + '/update' + '?ldiId=' + ldiId, opts)
}

export const fetchDayStats = (historyDays) => {
    const opts = securedApiOptions()
    let query = ''
    if (historyDays) {
        query += '?historyDays=' + historyDays
    }
    return handleApiCall(getLearningLoopApiUrl() + '/stats/day' + query, opts)
}

export const LearningLoopUpdateAvailabilityResult = {
    LDI_UPDATE_AVAILABLE: 'LDI_UPDATE_AVAILABLE',
    LDI_UPDATE_PROCESSING_ERROR: 'LDI_UPDATE_PROCESSING_ERROR',
    LDI_UPDATE_NO_UPDATE_NEEDED: 'LDI_UPDATE_NO_UPDATE_NEEDED',
}

export const LearningLoopUpdateResult = {
    LDI_UPDATE_NOTHING_TO_UPDATE: 'LDI_UPDATE_NOTHING_TO_UPDATE',
    LDI_UPDATE_SUCCESSFUL: 'LDI_UPDATE_SUCCESSFUL',
}

export const LearningLoopUpdateAvailabilityResultErrorReason = {
    LL_UPDATE_PACKET_VERSION_RECEIVED: 'LL_UPDATE_PACKET_VERSION_RECEIVED',
    LL_UPDATE_PACKET_VERSION_NOT_RECEIVED_FROM_KMS: 'LL_UPDATE_PACKET_VERSION_NOT_RECEIVED_FROM_KMS',
    LL_UPDATE_PACKET_VERSION_RECEIVED_WITH_FALSE_STATE: 'LL_UPDATE_PACKET_VERSION_RECEIVED_WITH_FALSE_STATE',
    LL_UPDATE_PACKET_VERSION_WRONG_DATA: 'LL_UPDATE_PACKET_VERSION_WRONG_DATA',
    LL_UPDATE_PACKET_NOT_SPECIFIED_ERROR: 'LL_UPDATE_PACKET_NOT_SPECIFIED_ERROR',
}
